/* eslint-disable no-console */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { updateRevenue } from "../../../Redux/Slices/revenue.slice";
import UpdateStatus from "../UpdateStatus";
import { PAYMENT_RECEIVER_TYPE, PAYMENT_STATUS } from "../data";
import {
  getDriverPaymentList,
  getPaymentKPI,
  updatePaymentStatus,
} from "../../../Redux/APIs/revenueAPI";
import useThreeDotsOptions from "./useThreeDotsOptions";

const LOCAL_DEFAULT_LIMIT = 10;

const ListDropdown = ({ detail }) => {
  const dispatch = useDispatch();

  const {
    paymentDetailsPopoverId,
    selectedPaymentDetailStatusId,
    collectionListCurrentPage,
  } = useSelector((state) => state.revenue);

  const [open, setOpen] = useState(false);

  const options = useThreeDotsOptions().filter((item) => item.hasPermission);

  const onOptionClick = async (optionId) => {
    // setOpen(false);

    switch (optionId) {
      case 1:
        dispatch(
          updateRevenue({
            key: "selectedPaymentDetailStatusId",
            value: detail.id,
          }),
        );
        break;

      default:
        break;
    }
  };

  const handleOpenChange = (state) => {
    if (!state) {
      dispatch(
        updateRevenue({
          key: "selectedPaymentDetailStatusId",
          value: 0,
        }),
      );
    }

    setOpen(state);

    dispatch(
      updateRevenue({
        key: "paymentDetailsPopoverId",
        value: detail.id,
      }),
    );
  };

  const handlePaymentStatus = async (newStatusId) => {
    if (detail.paymentStatus !== newStatusId) {
      await dispatch(
        updatePaymentStatus({
          paymentId: detail.id,
        }),
      );

      dispatch(
        getDriverPaymentList({
          offset: ((collectionListCurrentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
          limit: (collectionListCurrentPage || 1) * LOCAL_DEFAULT_LIMIT,
        }),
      );

      dispatch(getPaymentKPI());
    }

    setOpen(false);
    dispatch(
      updateRevenue({
        key: "selectedPaymentDetailStatusId",
        value: 0,
      }),
    );
  };

  // do not show the option:
  // 1. for farmers
  // 2. if the payment is completed
  if (
    +detail.entityType === PAYMENT_RECEIVER_TYPE.FARMER ||
    detail.paymentStatus === PAYMENT_STATUS.COMPLETED
  ) {
    return <div />;
  }

  // do not show the option if permission does not exist
  if (!options.length) {
    return <div />;
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open && paymentDetailsPopoverId === detail.id}
      arrow={false}
      onOpenChange={(state) => handleOpenChange(state)}
      content={
        <div
          className="rounded-md bg-background-white py-1 relative"
          style={{
            width: "156px",
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
          }}
        >
          {options.map((option) => (
            <button
              type="button"
              className="w-full flex items-center gap-x-3 px-3 py-2 group hover:bg-background"
              key={option.id}
              onClick={() => onOptionClick(option.id)}
            >
              {option.icon}
              <p className="font-aileron text-xs font-semibold capitalize text-dark-gray group-hover:text-black">
                {option.value}
              </p>
            </button>
          ))}

          {detail.id === selectedPaymentDetailStatusId && (
            <div className="mt-2 absolute">
              <UpdateStatus
                title="Payment Status"
                current={detail.paymentStatus}
                onClick={handlePaymentStatus}
              />
            </div>
          )}
        </div>
      }
    >
      <div className="cursor-pointer">
        <img src="/assets/icons/trips/more.svg" alt="dropdown" />
      </div>
    </Popover>
  );
};

export default ListDropdown;
